// extracted by mini-css-extract-plugin
module.exports = {"ChooseService":"Chooseservice_ChooseService__1ypCu","Root":"Chooseservice_Root__28vYB"};